import * as actionTypes from "../actionTypes";
import {DigitalContractService} from "../../api/digitalContractService";
import {store} from "../store";
import {toastError, toastSuccess} from "../../shared/components/toast/Toast";
import * as storageConstants from "../../shared/utils/constants/storage";
import fileSaver from 'file-saver'

export const getBulkCardData = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_BULK_CARDS, value: true})
        DigitalContractService.fetchBulkListCards(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_BULK_CARD_DATA,
                    payload: res.data
                })
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_BULK_CARDS, value: false})
            })
    }
}

export const fetchPlanOptionsForSim = (iccId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_PLAN_OPTIONS_FOR_SIM, value: true})
        DigitalContractService.fetchPlanOptionsForSim(iccId, integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.FETCH_PLAN_OPTIONS_FOR_SIM,
                    availablePlans: res.data.availablePlans,
                    currentOffer: res.data.currentOfferta
                })
            })
            .catch(e => {
                console.error(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_PLAN_OPTIONS_FOR_SIM, value: false})
            })
    }
}


export const fetchOfferForNewPlan = (newCommercialLabel, oldCommercialLabel) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_OFFER_FOR_NEW_PLAN, value: true})
        DigitalContractService.fetchOfferForNewPlan(newCommercialLabel, oldCommercialLabel, integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.FETCH_OFFER_FOR_NEW_PLAN,
                    data: res.data
                })
            })
            .catch(e => {
                toastError("Errore durante il caricamento della nuova offerta")
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_OFFER_FOR_NEW_PLAN, value: false})
            })
    }
}

export const fetchBulkDetailsContent = (bulkId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "bulk", loading: true})
        DigitalContractService.fetchBulkDetailsContent(integrationId, bulkId)
            .then((res) => {
                if (res.data.id) {
                    dispatch({
                        type: actionTypes.SET_BULK_DETAILS_CONTENT,
                        data: res.data
                    })
                    fetchBulkDetailsAssociatedSims(dispatch, integrationId, res.data.groupKey, res.data.bulkType)
                    fetchNotAssociatedSims(dispatch, integrationId, res.data.groupKey, res.data.bulkType)
                } else {
                    window.location.reload();
                }

            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "bulk", loading: false})
            })
    }
}

// This call should be executed after main details for bulk are fetched
// in order to optimize performance
const fetchBulkDetailsAssociatedSims = (dispatch, integrationId, groupKey, tipoPiano) => {
    dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "associatedSims", loading: true})
    DigitalContractService.fetchBulkDetailsAssociatedSims(integrationId, groupKey, tipoPiano)
        .then((res) => {
            dispatch({
                type: actionTypes.SET_BULK_DETAILS_ASSOCIATED_SIMS,
                data: res.data
            })
        })
        .catch((e) => {
            console.log(e)
        })
        .finally(() => {
            dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "associatedSims", loading: false})
        })
}

export const fetchBulkDetailsOffer = (bulkId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "offer", loading: true})
        DigitalContractService.fetchBulkDetailsOffer(bulkId, integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.SET_BULK_DETAILS_OFFER,
                    data: res.data
                })
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "offer", loading: false})
            })
    }
}

export const fetchNotAssociatedSims = (dispatch, integrationId, groupKey, tipoPiano) => {
    dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "notAssociatedSims", loading: true})
    DigitalContractService.fetchBulkDetailsNotAssociatedSims(integrationId, groupKey, tipoPiano)
        .then(res => {
            dispatch({
                type: actionTypes.FETCH_BULK_DETAILS_NOT_ASSOCIATED_SIMS,
                data: res.data
            })
        })
        .catch(e => {
            console.log(e)
        })
        .finally(() => {
            dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "notAssociatedSims", loading: false})
        })

}

export const deleteGroupMembers = (groupKey, msisdnList, tipoPiano, simMieCount, simConsociataCount) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    const deleteGroupMemberDto = {
        integrationId: integrationId,
        groupKey: groupKey,
        msisdnList: msisdnList
    }

    return dispatch => {
        dispatch({type: actionTypes.SET_BULK_DETAILS_ACTION_LOADING, name: "disassociateActionLoading", loading: true})
        DigitalContractService.deleteGroupMembers(deleteGroupMemberDto)
            .then(() => {
                toastSuccess(`Operazione avvenuta con successo`)
                fetchBulkDetailsAssociatedSims(dispatch, integrationId, groupKey, tipoPiano)
                // TODO: fetch not associated sims
                updateNotAssociatedSims(dispatch, integrationId, groupKey, tipoPiano)
                dispatch({
                    type: actionTypes.UPDATE_SIM_ASSOCIATE_BULK,
                    mieCount: -simMieCount,
                    consociataCount: -simConsociataCount
                })
            })
            .catch(e => {
                toastError('Operazione non riuscita. Riprovare.')
                console.log(e)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.SET_BULK_DETAILS_ACTION_LOADING,
                    name: "disassociateActionLoading",
                    loading: false
                })
            })
    }
}

export const addGroupMembers = (groupKey, msisdnList, tipoPiano, simMieCount, simConsociataCount) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    const addGroupMembersDto = {
        integrationId: integrationId,
        groupKey: groupKey,
        msisdnList: msisdnList
    }

    return dispatch => {
        // TODO: Dispatch loader
        dispatch({type: actionTypes.SET_BULK_DETAILS_ACTION_LOADING, name: "associateActionLoading", loading: true})
        DigitalContractService.addGroupMembers(addGroupMembersDto)
            .then(() => {
                toastSuccess(`Operazione avvenuta con successo.`)
                fetchBulkDetailsAssociatedSims(dispatch, integrationId, groupKey, tipoPiano)
                // TODO: fetch not associated sims
                updateNotAssociatedSims(dispatch, integrationId, groupKey, tipoPiano)
                dispatch({
                    type: actionTypes.UPDATE_SIM_ASSOCIATE_BULK,
                    mieCount: simMieCount,
                    consociataCount: simConsociataCount
                })
            })
            .catch(e => {
                toastError('Operazione non riuscita. Riprovare.')
                console.log(e);
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.SET_BULK_DETAILS_ACTION_LOADING,
                    name: "associateActionLoading",
                    loading: false
                })
            })
    }
}

const updateNotAssociatedSims = (dispatch, integrationId, groupKey, tipoPiano) => {
    dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "notAssociatedSims", loading: true})
    DigitalContractService.fetchBulkDetailsNotAssociatedSims(integrationId, groupKey, tipoPiano)
        .then(res => {
            dispatch({
                type: actionTypes.FETCH_BULK_DETAILS_NOT_ASSOCIATED_SIMS,
                data: res.data
            })
        })
        .catch(e => {
            console.log(e)
        })
        .finally(() => {
            dispatch({type: actionTypes.SET_LOADING_BULK_DETAILS, name: "notAssociatedSims", loading: false})
        })
}

export const fetchAddRemoveTokenOptions = (iccId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_ADD_REMOVE_OPTIONS, value: true})
        DigitalContractService.fetchAddRemoveOptions(iccId, integrationId)
            .then(res => {
                dispatch({
                    type: actionTypes.FETCH_ADD_REMOVE_OPTIONS,
                    data: res.data
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_ADD_REMOVE_OPTIONS, value: false})
            })
    }
}

export const downloadBulkAssociatedSimsCsv = (groupKey, tipoPiano, bulkName) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    return (dispatch) => {
        dispatch({type: actionTypes.SET_BULK_CSV_DOWNLOAD_LOADING, payload: true})
        DigitalContractService.downloadCsvBulkAssociatedSims(integrationId, groupKey, tipoPiano).then((res) => {
            fileSaver.saveAs(res.data, `SIM_extrashare_${bulkName}_${new Date().toISOString().split('T')[0]}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_BULK_CSV_DOWNLOAD_LOADING, payload: false})
        })
    }
}

export const extraShareSetSelectedTab = (value) => {
    sessionStorage.setItem(storageConstants.EXTRA_SHARE_TAB, value);
    return {
        type: actionTypes.SET_SELECTED_TAB_EXTRA_SHARE,
        selectedTab: value
    }
}
